import type { RoleModel } from '@snowit/types/permissions';

import useFirebase from '@snowit/firebase';

/**
 * This functions should not require special permissions
 */
export default () => {
  const firebase = useFirebase();

  const getRoles = async (): Promise<RoleModel[]> => {
    return firebase.query<RoleModel>({ collectionName: 'roles', filters: (q) => q.limit(0) });
  };

  const writeRole = async (data: RoleModel) => {
    try {
      await firebase.write({ collectionName: 'roles', id: data.uid, data });
    } catch (e) {
      console.error(e);
    }
  };

  const deleteRole = async (id: string) => {
    try {
      await firebase.delete({ collectionName: 'roles', id });
    } catch (e) {
      console.error(e);
    }
  };

  return {
    getRoles,
    writeRole,
    deleteRole,
  };
};
